import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {removeNullFromObject} from '@common/core/utils/remove-null-from-object';

interface UtmBuilderDialogComponentData {
    utmQuery?: string;
}

@Component({
    selector: 'utm-builder-dialog',
    templateUrl: './utm-builder-dialog.component.html',
    styleUrls: ['./utm-builder-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UtmBuilderDialogComponent implements OnInit {
    public form = this.fb.group({
        utm_source: this.fb.control(null),
        utm_medium: this.fb.control(null),
        utm_campaign: this.fb.control(null),
        utm_term: this.fb.control(null),
        utm_content: this.fb.control(null),
    });

    constructor(
        private dialogRef: MatDialogRef<UtmBuilderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UtmBuilderDialogComponentData,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.hydrateForm();
    }

    save() {
        this.dialogRef.close(this.formToUrlParams().toString());
    }

    close() {
        this.dialogRef.close();
    }

    private hydrateForm() {
        if (this.data.utmQuery) {
            const params = new URLSearchParams(this.data.utmQuery);
            const formValue = {};
            params.forEach((value: string, key: string) => {
                formValue[key] = value;
            });
            this.form.patchValue(formValue);
        }
    }

    private formToUrlParams(): URLSearchParams {
        return new URLSearchParams(
            removeNullFromObject(this.form.value)
        );
    }
}
